import { render, staticRenderFns } from "./PickingOffTheShelf.vue?vue&type=template&id=4971ba6c&scoped=true&"
import script from "./PickingOffTheShelf.vue?vue&type=script&lang=js&"
export * from "./PickingOffTheShelf.vue?vue&type=script&lang=js&"
import style0 from "./PickingOffTheShelf.vue?vue&type=style&index=0&id=4971ba6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971ba6c",
  null
  
)

export default component.exports